module.exports = __webpack_public_path__ + "static/media/menu-adders-white.2660b7e2.svg";